/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Choice_ErrorInputs */

const fr_plan_choice_error = /** @type {(inputs: Plan_Choice_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de lancer le paiement. Veuillez réessayer ou contacter l'équipe.`)
};

/**

* @param {Plan_Choice_ErrorInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const plan_choice_error = /** @type {((inputs?: Plan_Choice_ErrorInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Choice_ErrorInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_plan_choice_error(inputs)
});